// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-weather-deviation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-weather-deviation/atc-weather-deviation.js';

mount([g0]);
